import React, { useId } from "react";
import { useField } from "formik";
import ErrorHandling from "shared/ErrorHandling";
import styles from "./SelectField.module.scss";

const SelectField = ({
    label,
    options,
    placeholder = "Please select...",
    className = "",
    ...props
}) => {
    const [field, meta] = useField(props);
    const id = useId();
    const error = meta.touched && meta.error;
    const value = field.value || "";

    const selectClassName = [
        styles.select,
        value ? "" : styles.isPlaceholder,
        error ? styles.hasError : ""
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <div className={`${styles.field} ${className}`}>
            <label className={styles.label} htmlFor={id}>
                {label}
            </label>
            <div className={styles.selectWrapper}>
                <select
                    id={id}
                    className={selectClassName}
                    {...field}
                    {...props}
                    value={value}
                >
                    <option value="" disabled>
                        {placeholder}
                    </option>
                    {options.map((option) => (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    ))}
                </select>
            </div>
            {error && <ErrorHandling error={meta.error} />}
        </div>
    );
};

export default SelectField;
